import React, { useState } from "react"
import { Grid, Typography } from "@material-ui/core"
import { makeStyles } from "@material-ui/core/styles"
import CampaignModal from "molecules/CampaignModal"
import { backgroundFixed } from "utils/backgroundFixed.js"

const useStyle = makeStyles(theme => ({
  wrapper: {
    display: "inline-block", // 子要素に幅を合わせる
    margin: "10px 0 10px",
    position: "relative", // 以下inline-blockのため親要素に依存せず中央寄せ
    left: "50%",
    transform: "translateX(-50%)",
  },
  campaignCautionMiniText: {
    color: "#333333",
    fontSize: "11px",
    [theme.breakpoints.down("md")]: {
      maxWidth: "345px",
    },
  },
  actionLinkItem: {
    marginLeft: "auto", // 右寄せ
  },
  likeLink: {
    display: "inline-block",
    fontSize: "16px",
    color: "#3374da",
    cursor: "pointer",
    fontWeight: "bold",
    textDecoration: "underline",
  },
}))

const CampaignBottomTerm = () => {
  const classes = useStyle()
  const [campaignModalOpen, setCampaignModalOpen] = useState(false)

  const handleCpClose = () => {
    setCampaignModalOpen(false)
    backgroundFixed(false)
  }

  return (
    <div className={classes.wrapper}>
      <Grid container direction="column" alignItems="center">
        <Grid item>
          <Typography className={classes.campaignCautionMiniText}>
            ※同意いただいた月から起算して翌々月末日まで継続いただいた方がプレゼント対象です
          </Typography>
        </Grid>
        <Grid item className={classes.actionLinkItem}>
          <Typography
            id="campaignModalOpen"
            className={classes.likeLink}
            onClick={() => setCampaignModalOpen(true)}
          >
            キャンペーン規約はこちら
          </Typography>
        </Grid>
      </Grid>
      <CampaignModal
        id="campaignModal"
        open={campaignModalOpen}
        onClose={handleCpClose}
        onBackground={handleCpClose}
      />
    </div>
  )
}

export default CampaignBottomTerm
